const _wishlistCache = {
  loaded: false,
  items: [],
  metafieldId: null
};
let rawMainProductData = null;
let isReminderEnabled = false; // Global flag for the reminder feature


function waitForElement(selector) {
  return new Promise(resolve => {
    const element = document.querySelector(selector);
    if (element) return resolve(element);
    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
}

function createCleanProductObject(fullProduct) {
  if (!fullProduct || !fullProduct.id) {
    console.error("Wishlist OMC: Attempted to clean an invalid or null product object.", fullProduct);
    return null;
  }
  const formatPrice = (priceInCents) => {
    if (priceInCents === null || priceInCents === undefined) return "";
    const locale = typeof Shopify !== 'undefined' ? Shopify.locale : 'en-US';
    const currency = typeof Shopify !== 'undefined' ? Shopify.currency.active : 'USD';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(priceInCents / 100);
    } catch (e) {
      return `$${(priceInCents / 100).toFixed(2)}`;
    }
  };
  const firstVariant = fullProduct.variants?.[0] || {};
  return {
    id: String(fullProduct.id), name: fullProduct.title, price: formatPrice(fullProduct.price), image: fullProduct.featured_image,
    description: fullProduct.body_html ? fullProduct.body_html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().substring(0, 250) + '...' : '',
    url: `/products/${fullProduct.handle}`, vendor: fullProduct.vendor, type: fullProduct.type, tags: fullProduct.tags,
    variants: fullProduct.variants, available: fullProduct.available, compareAtPrice: formatPrice(fullProduct.compare_at_price),
    weight: firstVariant.weight, sku: firstVariant.sku
  };
}

function storeRecentlyViewedProduct(product) {

    console.log("recentlyViewd", product)
  if (!product || !product.id) return;
  const cleanProduct = createCleanProductObject(product);
  if (!cleanProduct) return;
  let recentlyViewed = JSON.parse(sessionStorage.getItem('recentlyViewed')) || [];
  recentlyViewed = recentlyViewed.filter(item => String(item.id) !== String(cleanProduct.id));
  recentlyViewed.unshift(cleanProduct);
  if (recentlyViewed.length > 10) {
    recentlyViewed.pop();
  }
  sessionStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
}

// --- INITIALIZATION ---
async function main() {
  console.log("Wishlist OMC: Main script started.");
  const dataContainer = await waitForElement("#collection-wishlist-data");
  
  const getSetting = (key, fallback) => dataContainer.dataset[key] || fallback;
  window.wishlistIconSettings = {
    activeColor: getSetting('iconColorActive', '#DA0000'),
    inactiveColor: getSetting('iconColorInactive', '#000000'),
    size: getSetting('iconSize', '27'),
  };
  try {
    window.customerData = JSON.parse(dataContainer.dataset.customer || '{}');
    window.customerId = window.customerData?.id;
    window.customerEmail = window.customerData?.email;
  } catch (e) { window.customerData = {}; }

  await fetchCampaignSettings();
  await loadInitialWishlist(); // This will render the initial icon states
  
  // --- NEW: EVENT DELEGATION ---
  if (document.querySelector('.collection-wishlist-icon-wrapper')) {
    initializeCollectionIcons(document.body);
    observeForNewProducts();
  }

const mainProductContainer = document.getElementById("wishlist-data");

if (mainProductContainer) {
  console.log("Wishlist product11:");
  const rawProductScript = document.getElementById("wishlist-product-json");
  if (rawProductScript) {
    try {
      const rawMainProductData = JSON.parse(rawProductScript.textContent);
      console.log("Wishlist product:", rawMainProductData);

      storeRecentlyViewedProduct(rawMainProductData);
    } catch (e) {
      console.error("Wishlist OMC: Failed to parse main product JSON.", e);
    }
  }
}
  // We attach ONE listener to the body. This will handle clicks on all present and future icons.
  document.body.addEventListener('click', handleWishlistClick);
}
document.addEventListener("DOMContentLoaded", main);
async function handleWishlistClick(event) {
    // Find the closest wishlist button to where the user clicked.
    const iconButton = event.target.closest('.wishlist-icon-button');

    // If the click wasn't on or inside a wishlist button, do nothing.
    if (!iconButton) {
        return;
    }
    
    // Prevent default browser actions (like navigating a link).
    event.preventDefault();
    event.stopPropagation();

    // Prevent double-clicks while the function is running.
    if (iconButton.dataset.processing === 'true') {
        console.log("Wishlist OMC: Click ignored, already processing.");
        return;
    }
    iconButton.dataset.processing = 'true';

    try {
        const rawProduct = JSON.parse(iconButton.dataset.productJson);
        await toggleWishlistIcon(iconButton, rawProduct);
    } catch (e) {
        console.error('Wishlist OMC: Error handling wishlist click.', e);
    } finally {
        // ALWAYS release the lock, so the button can be clicked again.
        iconButton.dataset.processing = 'false';
    }
}
async function toggleWishlistIcon(element, rawProduct) {
  if (window.customerId) {
    await toggleLoggedInWishlist(element, rawProduct);
  } else {
    toggleGuestWishlist(element, rawProduct);
  }
}

function toggleGuestWishlist(element, rawProduct) {
    console.log("Wishlist OMC: Running dedicated GUEST toggle logic.");
    let wishlist = [];
    try {
        wishlist = JSON.parse(sessionStorage.getItem('wishlist') || '[]');
        if (!Array.isArray(wishlist)) wishlist = [];
    } catch { wishlist = []; }

    const cleanProduct = createCleanProductObject(rawProduct);
    if (!cleanProduct) return;
    
    const productIndex = wishlist.findIndex(p => String(p.id) === String(cleanProduct.id));

    if (productIndex === -1) {
        wishlist.push({ ...cleanProduct, dateAdded: new Date().toISOString() });
        element.innerHTML = createHeartSVG(true);
        createStatusToast("Added to Wishlist", "Redirecting to login...", "success");
    } else {
        wishlist.splice(productIndex, 1);
        element.innerHTML = createHeartSVG(false);
        createStatusToast("Removed from Wishlist", "Redirecting to login...", "success");
    }

    sessionStorage.setItem('wishlist', JSON.stringify(wishlist));
    _wishlistCache.items = wishlist;

    // REDIRECT LOGIC FOR GUEST USER
    window.location.href = '/pages/account';
}
// --- CORE WISHLIST LOGIC ---

async function toggleLoggedInWishlist(element, rawProduct) {
    console.log("Wishlist OMC: Running LOGGED-IN toggle logic.");
    try {
        const response = await fetch(`${baseURL}/wishlist/get_metafield/?customerId=${window.customerId}&shop=${Shopify.shop}&app=oh_my_customer`);
        if (!response.ok) throw new Error(`API responded with status ${response.status}`);
        const data = await response.json();
        const metafield = (data.metafields?.metafields || []).find(mf => mf.namespace === "wishlist" && mf.key === "items");
        _wishlistCache.items = metafield ? JSON.parse(metafield.value) : [];
        _wishlistCache.metafieldId = metafield ? metafield.id : null;
    } catch (error) {
        console.error("Wishlist OMC: Failed to re-sync wishlist.", error);
    }
    
    const cleanProduct = createCleanProductObject(rawProduct);
    if (!cleanProduct) return;

    const currentWishlist = _wishlistCache.items || [];
    const productIndex = currentWishlist.findIndex(item => String(item.id) === String(cleanProduct.id));
    let newWishlist;
    
    // REMINDER FUNCTIONALITY IS NOW OFF
    if (productIndex === -1) {
        const newItem = { ...cleanProduct, dateAdded: new Date().toISOString() };
        newWishlist = [...currentWishlist, newItem];
        element.innerHTML = createHeartSVG(true);
        createStatusToast("Added to Wishlist", "This item is now saved.", "success");
    } else {
        newWishlist = currentWishlist.filter(item => String(item.id) !== String(cleanProduct.id));
        element.innerHTML = createHeartSVG(false);
        createStatusToast("Removed from Wishlist", "This item has been removed.", "success");
    }
    
    _wishlistCache.items = newWishlist;
    // Pass null for reminderDetails as the feature is disabled
    await saveWishlist1(newWishlist, cleanProduct, null); 
}




// --- API & DATA HANDLING ---
const baseURL = `https://omc.axentraos.co.in`;

async function fetchCampaignSettings() {
    try {
      const app = 'oh_my_customer';
      const url = `${baseURL}/campaign/get_campaigns_shopify/?shop=${Shopify.shop}&app=${app}`;
      const response = await fetch(url);
      if (!response.ok) {
        console.warn("Wishlist OMC: Could not fetch campaign settings. Reminders will be disabled.");
        return; // Keep default isReminderEnabled = false
      }
      const data = await response.json();

      // Safely navigate the JSON object to find the reminder setting
      const campaign = data?.campaigns?.[0];
      const features = campaign?.campaign_json?.modules?.myWishlist?.features;

      if (features && Array.isArray(features)) {
        const reminderFeature = features.find(feature => feature.id === 'Reminders');
        if (reminderFeature) {
          isReminderEnabled = reminderFeature.enabled;
        }
      }
      console.log(`Wishlist OMC: Reminders feature is ${isReminderEnabled ? 'ENABLED' : 'DISABLED'}.`);
    } catch (error) {
      console.error("Wishlist OMC: Error fetching campaign settings:", error);
      // isReminderEnabled will remain false in case of an error
    }
}
function renderInitialIconStates() {
    const rootElement = document.body;
    console.log("Wishlist OMC: Rendering initial icon states.");
    const wishlistedProductIds = new Set(_wishlistCache.items.map(item => String(item.id)));
    const placeholders = rootElement.querySelectorAll('.wishlist-icon-button[data-product-id]');
    
    placeholders.forEach(iconEl => {
        const productId = iconEl.dataset.productId;
        const isInWishlist = wishlistedProductIds.has(productId);
        // Only update the SVG, don't touch listeners.
        if (!iconEl.querySelector('svg') || iconEl.dataset.wishlistState !== String(isInWishlist)) {
            iconEl.innerHTML = createHeartSVG(isInWishlist);
            iconEl.dataset.wishlistState = String(isInWishlist);
        }
    });
}

async function loadInitialWishlist() {
    if (_wishlistCache.loaded) return;
    console.log("Wishlist OMC: Performing initial wishlist fetch...");

    if (window.customerId) {
        try {
            const response = await fetch(`${baseURL}/wishlist/get_metafield/?customerId=${window.customerId}&shop=${Shopify.shop}&app=oh_my_customer`);
            if (!response.ok) throw new Error(`API responded with status ${response.status}`);
            const data = await response.json();
            const metafield = (data.metafields?.metafields || []).find(mf => mf.namespace === "wishlist" && mf.key === "items");
            if (metafield) {
                _wishlistCache.items = JSON.parse(metafield.value);
                _wishlistCache.metafieldId = metafield.id;
            } else {
                await createEmptyMetafield();
            }

            // --- PAGE-SPECIFIC SYNC ---
            if (window.location.pathname.includes("/products/")) {
                // Product page: use local function
                if (typeof syncSessionWishlistToMetafield1 === "function") {
                    await syncSessionWishlistToMetafield1();
                    console.log("Wishlist OMC: Product page session wishlist synced.");
                }
            } else if (window.location.pathname.includes("/pages/account")) {
                // Account page: call global function
                if (typeof syncSessionWishlistToMetafield === "function") {
                    await syncSessionWishlistToMetafield();
                    console.log("Wishlist OMC: Account page session wishlist synced.");
                }
            }

        } catch (error) {
            console.error("Wishlist OMC: Error during initial wishlist load.", error);
        }
    } else {
        try {
            const guestWishlistRaw = sessionStorage.getItem("wishlist");
            const items = guestWishlistRaw ? JSON.parse(guestWishlistRaw) : [];
            _wishlistCache.items = Array.isArray(items) ? items : [];
        } catch {
            _wishlistCache.items = [];
        }
        sessionStorage.setItem("wishlist", JSON.stringify(_wishlistCache.items));
    }

    _wishlistCache.loaded = true;
    console.log("Wishlist OMC: Initial wishlist loaded into cache.", _wishlistCache);
    renderInitialIconStates();
    
    // Observe new DOM nodes to render their initial state
    const observer = new MutationObserver(() => renderInitialIconStates());
    observer.observe(document.body, { childList: true, subtree: true });
}


async function saveWishlist1(wishlist, product, reminderDetails) {
  if (window.customerId) {
    if (!_wishlistCache.metafieldId) {
      // First-time save for a logged-in user or recovery from a failed load.
      console.log("Wishlist OMC: No metafield ID found. Initiating first-time save process.");
      
      // The wishlist passed in already contains the new item. We just need to merge any old session items.
      const sessionWishlist = JSON.parse(sessionStorage.getItem("wishlist")) || [];
      const combinedWishlist = [...wishlist];
      const existingIds = new Set(wishlist.map(item => String(item.id)));
      
      sessionWishlist.forEach(item => {
        if (!existingIds.has(String(item.id))) {
          combinedWishlist.push(item);
        }
      });
      
      // Step 1: Create the container
      const creationSuccess = await createEmptyMetafield();
      
      // Step 2: If created, update it with the full list
      if (creationSuccess) {
        console.log("Wishlist OMC: Empty metafield created. Now updating with items.");
        await updateMetafield(combinedWishlist, product, reminderDetails);
        sessionStorage.removeItem("wishlist"); // Clean up session
      } else {
        console.error("Wishlist OMC: Failed to create metafield, cannot save wishlist. Caching locally.");
        _wishlistCache.items = combinedWishlist; // Keep merged list in cache for retry
      }
    } else {
      // Standard update for an existing user.
      await updateMetafield(wishlist, product, reminderDetails);
    }
  } else {
    // Guest user: save to session storage.
    sessionStorage.setItem("wishlist", JSON.stringify(wishlist));
    console.log("Wishlist OMC: Saved to session storage for guest user.");
  }
}

async function createEmptyMetafield() {
    if (!window.customerId) return false;
    try {
        const payload = {
            customerId: window.customerId, shop: Shopify.shop, app: "oh_my_customer",
            metafield: { namespace: "wishlist", key: "items", value: JSON.stringify([]), type: "json" },
        };
        const response = await fetch(`${baseURL}/wishlist/create_metafield/`, {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error(`API responded with status ${response.status}`);
        const newData = await response.json();
        if (newData?.metafield?.id) {
            _wishlistCache.metafieldId = newData.metafield.id;
            console.log("Wishlist OMC: Successfully created new empty metafield with ID:", _wishlistCache.metafieldId);
            return true;
        } else {
            throw new Error("Create metafield response did not contain a valid ID.");
        }
    } catch (error) {
        console.error("Wishlist OMC: Error creating empty metafield:", error);
        return false;
    }
}

async function updateMetafield(wishlist, product, reminderDetails) {
    if (!window.customerId || !_wishlistCache.metafieldId) {
        console.error("Wishlist OMC: Cannot update metafield without customerId and metafieldId.");
        return;
    }
    try {
        const payload = {
            customerId: window.customerId, metafieldId: _wishlistCache.metafieldId, shop: Shopify.shop, app: "oh_my_customer",
            metafield: { id: _wishlistCache.metafieldId, value: JSON.stringify(wishlist), type: "json" },
            productId: product?.id, caldate: reminderDetails?.date, caltime: reminderDetails?.time, email: window.customerEmail
        };
        const response = await fetch(`${baseURL}/wishlist/update_metafield/`, {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error(`API responded with status ${response.status}`);
        _wishlistCache.items = wishlist; // Update cache with the successfully saved list
        console.log("Wishlist OMC: Background save to metafield successful.");
    } catch (error) {
        console.error("Wishlist OMC: Error saving wishlist to metafield:", error);
    }
}


async function syncSessionWishlistToMetafield1() {
  const sessionWishlist = JSON.parse(sessionStorage.getItem("wishlist")) || [];
  
  if (sessionWishlist.length > 0 && window.customerId) {
    console.log("Wishlist OMC: Found items in session. Syncing to user's account...");
    
    const combined = [..._wishlistCache.items];
    const existingIds = new Set(_wishlistCache.items.map(item => String(item.id)));
    let itemsWereAdded = false;
    
    sessionWishlist.forEach((item) => {
      if (!existingIds.has(String(item.id))) { 
        combined.push(item);
        itemsWereAdded = true;
      }
    });
    
    if (itemsWereAdded) {
      // Corrected: Pass null for the product/reminder details as this is a bulk sync.
      await saveWishlist1(combined, null, null); 
      sessionStorage.removeItem("wishlist");
      console.log("Wishlist OMC: Guest-to-user sync complete.");
    } else {
      sessionStorage.removeItem("wishlist");
      console.log("Wishlist OMC: Session wishlist contained only duplicates, cleared session.");
    }
  }
}

// --- PAGE-SPECIFIC INITIALIZERS ---
function initMainProductIcon(rawProduct) {
    const isInWishlist = _wishlistCache.items.some((item) => String(item.id) === String(rawProduct.id));
    const container = document.getElementById("wishlist-icon-container");
    if (!container) return;
    container.innerHTML = `<span class="wishlist-icon-button" style="cursor: pointer;">${createHeartSVG(isInWishlist)}</span>`;
    container.firstElementChild.addEventListener('click', (e) => {
        toggleWishlistIcon(e.currentTarget, rawProduct);
    });
}

function initializeCollectionIcons(rootElement) {
    const wishlistedProductIds = new Set(_wishlistCache.items.map(item => String(item.id)));
    const placeholders = rootElement.querySelectorAll('.wishlist-icon-button[data-product-id]:not([data-wishlist-initialized])');
    
    placeholders.forEach(iconEl => {
        iconEl.setAttribute('data-wishlist-initialized', 'true');
        const productId = iconEl.dataset.productId;
        const isInWishlist = wishlistedProductIds.has(productId);
        iconEl.innerHTML = createHeartSVG(isInWishlist);
        // The event listener is no longer needed here. 
        // The main 'handleWishlistClick' on document.body will handle it.
    });
}
function observeForNewProducts() {
    const observer = new MutationObserver(() => {
        initializeCollectionIcons(document.body);
    });
    observer.observe(document.body, { childList: true, subtree: true });
}


function createHeartSVG(isFilled) {
  const { size, activeColor, inactiveColor } = window.wishlistIconSettings;
  const color = isFilled ? activeColor : inactiveColor;
  const fillAttribute = isFilled ? `fill="${color}"` : 'fill="white "';
  const fillColor = isFilled ? color : "white";
  const strokeAttribute = `stroke="${color}" stroke-width="0.7"`;
   const styleAttribute = `style="fill:${fillColor} !important; stroke:${color} !important; stroke-width:0.7 !important;"`;
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" ${styleAttribute} stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>`;
}
function createStatusToast(title, message, status = "success") {
  const isSuccess = status === "success";const mainColor = isSuccess ? "#22C55E" : "#EF4444";const titleText = title;const existing = document.querySelector(".toast-wrapper");if (existing) existing.remove();const wrapper = document.createElement("div");wrapper.className = "toast-wrapper";wrapper.style.cssText ="position: fixed; bottom: -150px; right: 20px; z-index: 9999; width: 360px; transition: bottom 0.4s ease-out; animation: slideUp 0.4s forwards;";const toast = document.createElement("div");toast.style.cssText ="width: 100%; height: 100%; background-color: #fff; box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15); display: flex; align-items: flex-start; gap: 1rem; padding: 12px 16px 16px 16px; position: relative;";toast.innerHTML = `<div style="font-size: 14px !important; color: ${mainColor}; margin-top: 5px !important;">${isSuccess? `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="${mainColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="${mainColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`}</div><div style="display: flex; flex-direction: column; flex: 1;"><div style="display: flex; align-items: first baseline; margin-bottom: 4px;"><div style="display: block; width: 8px; height: 8px; border-radius: 50%; background-color: ${mainColor}; margin-right: 8px;"></div><span style="font-size: 15px !important; color: #000;">${titleText}</span></div><div style="font-size: 14px !important; color: #4b5563; line-height: 1.3;">${message}</div></div><button style="background: none; border: none; font-size: 16px !important; color: #7c7c7c; cursor: pointer; position: relative; top: -15px; right: -15px;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>`;toast.querySelector("button").addEventListener("click", () => wrapper.remove());wrapper.appendChild(toast);document.body.appendChild(wrapper);const style = document.createElement("style");style.innerHTML = `@keyframes slideUp { 0% { bottom: -150px; opacity: 0; } 100% { bottom: 20px; opacity: 1; } }`;document.head.appendChild(style);setTimeout(() => wrapper.remove(), 5000);
}

// This function is no longer called but is kept in case it's needed in the future.
function renderCalendarUI(product_name) {
    const modal = document.createElement("div");
    modal.innerHTML = `
        <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:1000">
            <div style="background:white;padding:20px;width:330px;box-shadow:0 4px 10px rgba(0,0,0,0.3);position:relative; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;">
                <span id="closeCross" style="cursor:pointer;font-size:24px;font-weight:bold;color:#555;position:absolute;right:15px;top:10px; line-height: 1;">&times;</span>
                <div style="text-align:center; margin-bottom: 20px;">
                    <span style="font-size:18px;font-weight:600;color:#111;">Set a Reminder</span>
                </div>
                <div style="padding:10px 0;">
                    <label style="font-size:14px; color:#333; display: block; margin-bottom: 15px;">For Product: <strong style="color: #000;">${product_name}</strong></label>
                    
                    <div style="margin-bottom: 15px;">
                        <label for="reminderDateInput" style="display:block; font-weight:bold; margin-bottom:5px; color:#111; font-size:14px;">Reminder Date</label>
                        <input type="date" id="reminderDateInput" style="width:100%;padding:8px;border-radius:4px;border:1px solid #ccc;font-size:14px;box-sizing: border-box;">
                    </div>

                    <div>
                        <label for="timeSelect" style="display:block; font-weight:bold; margin-bottom:5px; color:#111; font-size:14px;">Reminder Time</label>
                        <select id="timeSelect" style="width:100%;padding:8px;border-radius:4px;border:1px solid #ccc;font-size:14px;box-sizing: border-box; background-color: white;">
                            ${Array.from({ length: 24 }, (_, i) => {
                                const hour = i % 12 === 0 ? 12 : i % 12;
                                const ampm = i < 12 ? "AM" : "PM";
                                return `<option value="${String(i).padStart(2, "0")}:00">${hour}:00 ${ampm}</option>`;
                            }).join("")}
                        </select>
                    </div>
                </div>
                <div style="display:flex;justify-content:end;align-items:center;gap:10px;margin-top:25px;">
                    <button id="closeModal" style="background:#f0f0f0;color:#333;border:1px solid #ccc;padding:8px 16px;cursor:pointer;font-size:14px;font-weight:500;border-radius:4px;">Cancel</button>
                    <button id="setReminder" style="background:black;color:white;border:1px solid black;padding:8px 16px;cursor:pointer;font-size:14px;font-weight:500;border-radius:4px;">Set Reminder</button>
                </div>
            </div>
        </div>
    `;

    const dateInput = modal.querySelector("#reminderDateInput");
    const timeSelect = modal.querySelector("#timeSelect");
    const today = new Date();
    dateInput.min = today.toISOString().slice(0, 10);

    const closeModal = () => {
        modal.remove();
        document.dispatchEvent(new CustomEvent("reminderSet", { detail: null }));
    };
    modal.querySelector("#closeModal").addEventListener("click", closeModal);
    modal.querySelector("#closeCross").addEventListener("click", closeModal);

    modal.querySelector("#setReminder").addEventListener("click", () => {
        const selectedDate = dateInput.value;
        const selectedTime = timeSelect.value;

        if (!selectedDate) {
            createStatusToast("Missing Reminder Date", "Please select a date to create your reminder.", "error");
            return;
        }

        const now = new Date();
        const reminderDateTime = new Date(`${selectedDate}T${selectedTime}`);
        
        if (selectedDate === now.toISOString().slice(0, 10) && reminderDateTime <= now) {
            createStatusToast("Time Selection Error", "The selected time is in the past. Please choose a future time.", "error");
            return;
        }

        modal.remove();
        document.dispatchEvent(new CustomEvent("reminderSet", { detail: { date: selectedDate, time: selectedTime } }));
    });

    return modal;
}